<template>
  <div>
    <el-form class="toolbar" :inline="true">
      <el-form-item label="统计区间">
        <el-date-picker v-model="query.startDate" type="date" value-format="yyyy-MM-dd" size="small" />
      </el-form-item>
      <el-form-item label="至">
        <el-date-picker v-model="query.endDate" type="date" value-format="yyyy-MM-dd" size="small" />
      </el-form-item>
      <el-form-item label="呆滞天数">
        <el-input-number v-model="query.sluggishDays" :min="1" :max="3650" size="small" />
      </el-form-item>
      <el-form-item label="TopN">
        <el-input-number v-model="query.topN" :min="5" :max="200" size="small" />
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('inventory:dashboard:list')" type="primary" size="small" :loading="loading" @click="load">刷新看板</el-button>
        <el-button size="small" @click="download('turnoverExport', '库存周转.xlsx')">导出周转</el-button>
        <el-button size="small" @click="download('sluggishExport', '呆滞库存.xlsx')">导出呆滞</el-button>
        <el-button size="small" @click="download('structureExport', '库存结构.xlsx')">导出结构</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="12" class="cards">
      <el-col :span="6"><el-card shadow="never">库存总量: {{ overview.quantityTotal || 0 }}</el-card></el-col>
      <el-col :span="6"><el-card shadow="never">可用总量: {{ overview.usableQuantityTotal || 0 }}</el-card></el-col>
      <el-col :span="6"><el-card shadow="never">在库产品数: {{ overview.materialCount || 0 }}</el-card></el-col>
      <el-col :span="6"><el-card shadow="never">预警条目数: {{ overview.warningCount || 0 }}</el-card></el-col>
    </el-row>
    <el-row :gutter="12">
      <el-col :span="12">
        <el-card shadow="never" header="周转天数（按产品）">
          <el-table :data="turnoverList" border size="small" max-height="360" :header-cell-style="headStyle">
            <el-table-column prop="materialCode" label="产品编码" min-width="120" />
            <el-table-column prop="materialName" label="产品名称" min-width="140" />
            <el-table-column prop="avgEndQty" label="平均库存" width="100" align="right" />
            <el-table-column prop="totalOutQty" label="累计出库" width="100" align="right" />
            <el-table-column prop="turnoverDays" label="周转天数" width="100" align="right" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never" header="呆滞库存（当前在库）">
          <el-table :data="sluggishList" border size="small" max-height="360" :header-cell-style="headStyle">
            <el-table-column prop="materialCode" label="产品编码" min-width="120" />
            <el-table-column prop="materialName" label="产品名称" min-width="140" />
            <el-table-column prop="wareHouseId" label="仓库" min-width="120" />
            <el-table-column prop="quantity" label="当前库存" width="100" align="right" />
            <el-table-column prop="lastOutDate" label="最近出库日" width="120" />
            <el-table-column prop="sluggishLevel" label="慢动销分层" width="100" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <el-card shadow="never" style="margin-top:12px" header="出入与结存趋势（日结存）">
      <div class="snapshot-note">此趋势取自每日结存快照。补录、审核或弃审库存单据后，请在“库存日结存”重建受影响日期及后续日期；上方库存总量和可用总量按当前库存实时统计。</div>
      <svg v-if="trendList.length" class="trend" viewBox="0 0 640 220" preserveAspectRatio="none">
        <polyline :points="line('inQty')" fill="none" stroke="#67c23a" stroke-width="2" />
        <polyline :points="line('outQty')" fill="none" stroke="#e6a23c" stroke-width="2" />
        <polyline :points="line('endQty')" fill="none" stroke="#409eff" stroke-width="2" />
      </svg>
      <div class="legend"><span class="in">入库</span><span class="out">出库</span><span class="end">结存</span></div>
      <el-table :data="trendList" border size="small" max-height="240" :header-cell-style="headStyle">
        <el-table-column prop="bizDate" label="日期" width="120" />
        <el-table-column prop="inQty" label="入库" align="right" />
        <el-table-column prop="outQty" label="出库" align="right" />
        <el-table-column prop="endQty" label="结存" align="right" />
      </el-table>
    </el-card>
    <el-card shadow="never" style="margin-top:12px" header="库存结构占比（按分类）">
      <el-table :data="structureList" border size="small" :header-cell-style="headStyle">
        <el-table-column prop="classifyName" label="分类" min-width="160" />
        <el-table-column prop="quantity" label="库存数量" width="140" align="right" />
        <el-table-column prop="ratio" label="占比(%)" width="140" align="right" />
      </el-table>
    </el-card>
  </div>
</template>
<script>
import request from '../../api/request'
import { authMixin } from './inventoryShared'
function day(offset) {
  const now = new Date()
  now.setDate(now.getDate() + offset)
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  return now.getFullYear() + '-' + m + '-' + d
}
export default {
  name: 'Dashboard',
  mixins: [authMixin],
  data() {
    return {
      query: { startDate: day(-29), endDate: day(0), sluggishDays: 30, topN: 20 },
      overview: {}, turnoverList: [], sluggishList: [], structureList: [], trendList: [], loading: false
    }
  },
  created() { this.load() },
  methods: {
    line(key) {
      const rows = this.trendList
      const max = Math.max(1, ...rows.map(row => Number(row.inQty || 0)), ...rows.map(row => Number(row.outQty || 0)), ...rows.map(row => Number(row.endQty || 0)))
      return rows.map((row, index) => {
        const x = rows.length === 1 ? 320 : (index * 640 / (rows.length - 1))
        const y = 200 - (Number(row[key] || 0) * 180 / max)
        return x + ',' + y
      }).join(' ')
    },
    load() {
      this.loading = true
      request.get('/inventory/dashboard', { params: this.query }).then(res => {
        const data = res.data || {}
        this.overview = data.overview || {}
        this.turnoverList = data.turnoverList || []
        this.sluggishList = data.sluggishList || []
        this.structureList = data.structureList || []
        this.trendList = data.trendList || []
      }).catch(() => {}).finally(() => { this.loading = false })
    },
    download(action, fileName) {
      request.get('/inventory/dashboard/' + action, { params: this.query, responseType: 'blob' }).then(res => {
        const blob = new Blob([res.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(() => {})
    }
  }
}
</script>
<style scoped>
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.cards { margin-bottom: 12px; }
.snapshot-note { margin-bottom: 10px; color: #606266; font-size: 13px; line-height: 20px; }
.trend { width: 100%; height: 220px; background: #f8fafc; border-radius: 6px; }
.legend { margin: 8px 0; font-size: 13px; }
.legend span { margin-right: 16px; }
.in { color: #67c23a; }
.out { color: #e6a23c; }
.end { color: #409eff; }
</style>
